import DesktopMacOutlinedIcon from '@mui/icons-material/DesktopMacOutlined';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PhoneIphoneRoundedIcon from '@mui/icons-material/PhoneIphoneRounded';
import Box from '@mui/material/Box';
import type { TargetingWithUrlTargeting } from '@openx/types/package';
import { useMemo } from 'react';

import {
  getIconColor,
  isCTVIconActive,
  isDesktopIconActive,
  isLocationIconActive,
  isPhoneIconActive,
  isUsersIconActive,
} from './utils';

type Props = {
  targeting?: TargetingWithUrlTargeting;
};

export const DealGroupControl = ({ targeting }: Props) => {
  const iconConfigs = useMemo(
    () => [
      { IconComponent: MyLocationIcon, condition: () => isLocationIconActive(targeting), name: 'location' },
      { IconComponent: PeopleAltIcon, condition: () => isUsersIconActive(targeting), name: 'users' },
      { IconComponent: LiveTvIcon, condition: () => isCTVIconActive(targeting), name: 'video' },
      { IconComponent: DesktopMacOutlinedIcon, condition: () => isDesktopIconActive(targeting), name: 'desktop' },
      { IconComponent: PhoneIphoneRoundedIcon, condition: () => isPhoneIconActive(targeting), name: 'phone' },
    ],
    [targeting]
  );

  if (!targeting) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
      }}
    >
      {iconConfigs.map(({ name, IconComponent, condition }) => (
        <IconComponent data-test={`deal-group-control-icon-${name}`} key={name} color={getIconColor(condition())} />
      ))}
    </Box>
  );
};
